import { Box } from '@chakra-ui/react';
import Messages from './messages';
import { RefObject } from 'react';

const ChatBox = ({
	messages,
	scrollContainerRef
}: {
	messages: any[];
	scrollContainerRef?: RefObject<HTMLDivElement>;
}) => {
	return (
		<Box w="full" style={{ scrollPaddingBottom: '170px' }}>
			{messages && <Messages conversation={messages ?? []} scrollContainerRef={scrollContainerRef} />}
		</Box>
	);
};

export default ChatBox;
